const autocompleteFormParamUser = {
  sites: 'Sitios',
  companies: 'Tercera empresa'
};

export default autocompleteFormParamUser;
